module.exports = __webpack_public_path__ + "img/501_yw.bottom.b42c2943.jpg";